import { OpenSpiritualServicesDetail, SpiritualServiceFlow } from './types';

export const SPIRITUAL_SERVICES_OPEN_EVENT = 'panoee:spiritual-services:open';

export const isSpiritualServiceFlow = (
  value: unknown,
): value is SpiritualServiceFlow =>
  value === 'contribution' ||
  value === 'incense' ||
  value === 'booking' ||
  value === 'lookup';

/**
 * Stable integration boundary for ChatAssistant and other tour actions.
 * This only opens/prefills a draft. Submission always stays in the dialog.
 */
export const openSpiritualServices = (detail: OpenSpiritualServicesDetail) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<OpenSpiritualServicesDetail>(
      SPIRITUAL_SERVICES_OPEN_EVENT,
      { detail },
    ),
  );
};
